var map = {
	"./de.json": 1307,
	"./en.json": 1308,
	"./nl.json": 1309
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 865;


//////////////////
// WEBPACK FOOTER
// /locales \.json.*$
// module id = 865
// module chunks = 0